"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { Spinner } from "@/components/ui/spinner";
import { clearDashboardSwitch, useDashboardSwitch } from "@/lib/dashboard-loading-label";
export function DashboardSwitchOverlay() {
  const $ = _c(9);
  const {
    isSwitching,
    destination,
    sourcePathname
  } = useDashboardSwitch();
  const pathname = usePathname();
  const navigationDone = isSwitching && sourcePathname !== null && pathname !== sourcePathname;
  let t0;
  let t1;
  if ($[0] !== navigationDone) {
    t0 = () => {
      if (navigationDone) {
        clearDashboardSwitch();
      }
    };
    t1 = [navigationDone];
    $[0] = navigationDone;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== isSwitching) {
    t2 = () => {
      if (!isSwitching) {
        return;
      }
      const timer = setTimeout(_temp, 8000);
      return () => clearTimeout(timer);
    };
    t3 = [isSwitching];
    $[3] = isSwitching;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (!isSwitching || !destination || navigationDone) {
    return null;
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Spinner className="size-6 text-muted-foreground" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== destination) {
    t5 = createPortal(<div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm"><div className="flex flex-col items-center gap-3">{t4}<p className="text-base text-muted-foreground">Switching to {destination}</p></div></div>, document.body);
    $[7] = destination;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp() {
  return clearDashboardSwitch();
}